export const CLEAR_ADVERSE_MEDIA_RELEVANCE_HIGH = 75;
export const CLEAR_ADVERSE_MEDIA_RELEVANCE_MEDIUM = 50;
export const CLEAR_ADVERSE_MEDIA_RELEVANCE_LOW = 0;

export const CLEAR_ADVERSE_MEDIA_RELEVANCE_COLOR_CODES = {
  [CLEAR_ADVERSE_MEDIA_RELEVANCE_HIGH]: 0,
  [CLEAR_ADVERSE_MEDIA_RELEVANCE_MEDIUM]: 5,
  [CLEAR_ADVERSE_MEDIA_RELEVANCE_LOW]: 2
};
